<template>
  <div class="app-container">
	<div class="head-container" style="margin-bottom: 10px;">
		<el-row :gutter="10" class="mb8">
		  <el-col :span="1.5">
		    <el-button
		      type="primary"
		      plain
		      size="mini"
		    >家族总人数:{{data.sumMember}}</el-button>
		  </el-col>
		  <el-col :span="1.5">
		    <el-button
		      type="primary"
		      plain
		      size="mini"
		    >家族总流水(本月):{{data.sumPrice}}</el-button>
		  </el-col>
		  <el-col :span="1.5">
		    <el-button
		      type="primary"
		      plain
		      size="mini"
		    >家族今日总流水:{{data.sumPriceByToDay}}</el-button>
		  </el-col>
		</el-row>
	</div>
    
    <el-table v-loading="loading" :data="data.runningWaterList" border>
      <el-table-column label="日期" align="center" prop="dateStr" />
      <el-table-column label="流水" align="center" prop="ls" />
    </el-table>
	

  </div>
</template>

<script>
  import { getGuildRevenueStatisticsInfo} from "@/api/gonghui";
  import Cookies from 'js-cookie'
  export default {
    data() {
      return {
        //打开用户详情
        openUserInfo: false,
        userInfo: {},
        // 遮罩层
        loading: false,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 显示搜索条件
        showSearch: true,
        // 总条数
        total: 0,
        // App用户表格数据
        list: [],
		data:'',
        // 弹出层标题
        title: "",
        // 是否显示弹出层
        open: false,
        // 查询参数
        queryParams: {
          page: 1,
          size: 10,
        },
      };
    },
    created() {
      const data = JSON.parse(Cookies.get('user'))
      this.queryParams.guildId = data.guildId
      this.getList();
    },
    methods: {
      /** 查询A列表 */
      getList() {
        this.loading = true;
        getGuildRevenueStatisticsInfo(this.queryParams).then(response => {
          this.data = response.data;
          this.loading = false;
        });
      },
    }
  };
  </script>
  <style scoped>

  </style>



// WEBPACK FOOTER //
// yingshoushuju.vue?cfcaadc6